<template>

    <div>

        <modal :showModal="showModal" :hideModal="closeModal" class="tigre-submit-modal">

            <h5 slot="header">{{exportResult}}</h5>

            <div v-if="fineExportsInError.length" slot="body" class="w-100">

                <div class="row pb-3">
                    <div class="col-12">Soumissions en erreur :</div>
                </div>

                <div id="fineInErrorContainer">

                    <template v-for="fineExportInError in fineExportsInError">

                        <hr/>

                        <div class="row">
                            <div class="col-2 pr-0"><b>Numéro :</b></div>
                            <div class="col-2 pr-0">{{ fineExportInError.fine_id }}</div>
                            <div class="col-2 pr-0"><b>Code retour :</b></div>
                            <div class="col-1 pr-0">{{ fineExportInError.export_result }}</div>
                            <div class="col-3 pr-0"><b>Code retour image :</b></div>
                            <div class="col-1 pr-0">{{ fineExportInError.export_image_result }}</div>
                        </div>

                    </template>

                </div>

            </div>

            <div slot="footer">
                <button class="btn btn-danger" @click="closeModal">Fermer</button>
            </div>

        </modal>

    </div>

</template>

<script>

    import Modal from './Modal';

    export default {
        name: 'fineExportResultModal',
        components: {Modal},
        props: {
            showModal: Boolean,
            closeModal: Function,
            exportResult: {
                type: String,
                required: true
            },
            fineExportsInError: {
                type: Array,
                default: []
            }
        }
    }

</script>

<style>

    .tigre-submit-modal .modal-dialog {
        max-width: 700px;
    }

    #fineInErrorContainer hr:first-child {
        display: none;
    }

</style>


// WEBPACK FOOTER //
// resources/js/components/layout/FineExportResultModal.vue